import { InstagramLogo, FacebookLogo, TiktokLogo } from "@phosphor-icons/react";
import QuietBayMark from "@/components/QuietBayMark";

// TODO: substituir pelos URLs reais da Quiet Bay assim que o cliente os enviar.
const SOCIAL = [
  { label: "Instagram", href: "https://instagram.com/quietbay", Icon: InstagramLogo, testid: "social-instagram" },
  { label: "Facebook", href: "https://facebook.com/quietbay", Icon: FacebookLogo, testid: "social-facebook" },
  { label: "TikTok", href: "https://tiktok.com/@quietbay", Icon: TiktokLogo, testid: "social-tiktok" },
];

export default function Footer() {
  return (
    <footer className="dark-section mt-32 relative" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <QuietBayMark size={42} color="#9D968D" />
            <div>
              <div className="font-display font-display-bold text-3xl text-[#F5F1EA] leading-none">Quiet Bay</div>
              <div className="font-display text-base text-[#B9D3DC]/80 mt-1.5">Far Beyond Hot <span className="amp" style={{ color: "#B9D3DC", opacity: 0.7 }}>&amp;</span> Cold</div>
            </div>
          </div>
          <p className="text-sm text-[#B9D3DC]/70 leading-relaxed max-w-sm mt-6">
            Cascais e Oeiras. Onde o calor abre, o frio sela e o oceano cuida do resto.
            Sessões de uma hora, até 8 pessoas.
          </p>

          <div className="mt-8 flex gap-3" data-testid="social-icons">
            {SOCIAL.map(({ label, href, Icon, testid }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                 className="w-10 h-10 border border-[#F5F1EA]/15 flex items-center justify-center text-[#B9D3DC]/80 hover:text-[#F5F1EA] hover:border-[#D69A2D] transition-colors"
                 aria-label={label}
                 data-testid={testid}>
                <Icon size={16} weight="light" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <p className="overline mb-5 text-[#B9D3DC]/60">Horário</p>
          <p className="text-sm text-[#F5F1EA]">Todos os dias</p>
          <p className="text-sm text-[#B9D3DC]/70 mt-1">08h00 – 20h00</p>
          <p className="text-xs text-[#B9D3DC]/55 mt-2">Última sessão inicia às 19h00</p>
        </div>
        <div>
          <p className="overline mb-5 text-[#B9D3DC]/60">Contacto</p>
          <p className="text-sm text-[#F5F1EA]">reservas@quietbay.me</p>
          <p className="text-sm text-[#B9D3DC]/70 mt-1">Cascais · Oeiras</p>
        </div>
      </div>
      <div className="border-t border-[#F5F1EA]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 text-xs text-[#9D968D] flex justify-between flex-wrap gap-2">
          <span>© {new Date().getFullYear()} Quiet Bay. Todos os direitos reservados.</span>
          <span>Pagamentos seguros via Stripe.</span>
        </div>
      </div>
    </footer>
  );
}
